import { extendObservable, action } from 'mobx';
import ConfigurationApi from '../psuite-js/apis/delivery/configuration';

const PSDELIVERY_SHOW_MENU = 'PSDELIVERY_SHOW_MENU';

class AppStore {

    constructor() {
        let show_menu = JSON.parse(localStorage.getItem(PSDELIVERY_SHOW_MENU));

        extendObservable(this, {
            show_menu: (show_menu === null) ? true : show_menu,
            toggleMenu: action(this.toggleMenu.bind(this)),

            configurations: {},
            fetching: false,
            is_fetched: false,
            fetch: action(this.fetch.bind(this)),
        });
    }

    toggleMenu() {
        this.show_menu = !this.show_menu;
        localStorage.setItem(PSDELIVERY_SHOW_MENU, JSON.stringify(this.show_menu));
        window.dispatchEvent(new Event('MenuToggle'));
    }

    async fetch() {
        this.fetching = true;

        const response = await ConfigurationApi.all();

        if (response.status === 200) {
            this.configurations = response.data.data;
            this.is_fetched = true;
        }

        this.fetching = false;
        return response;
    }
}

export default new AppStore();



// WEBPACK FOOTER //
// ./src/stores/app.js